import { render, staticRenderFns } from "./SupportMaterialView.vue?vue&type=template&id=7af13d20&"
import script from "./SupportMaterialView.vue?vue&type=script&lang=js&"
export * from "./SupportMaterialView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports